import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Docket from '../../entities/docket';
import Task from '../../entities/task';
export function deleteDocket(docket: Docket, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = docket.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('docketId', docket.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.docketId === docket.id) {
_task.docketId = null;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



docket.status = 'D';
docket.addedOn = newHRTimestamp();
docket.addedBy = getCurrentUserId();
docket.importSource = targetImportSource;
docket.importId = mergeId;
store.dispatch(Actions.DocketActions.removeDocketQueue(docket));
}
export function replaceDocket(docket: Docket, replaceWith: Docket, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = docket.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('docketId', docket.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.docketId === docket.id) {
_task.docketId = replaceWith.id;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



return docket;
}
export function deleteImpactDocket(docket: Docket) {
const impacts: string[] = [];
const state = store.getState();
const taskDocketIdImpact = state.tasks.getMappingFor('docketId', docket.id).filter(task => task.status !== 'D');
taskDocketIdImpact.forEach(() => impacts.push('tasks'));



return util.countDistinct(impacts);
}
